import Component from "@glimmer/component"
import type { ExplainerSlice } from "@shared/models/prismic-explainer"
import styles from "./explainer-buttons.module.css"

interface Args {
  step: ExplainerSlice
  back: Function
  next: Function
}
export default class ExplainerButtonComponent extends Component<Args> {
  readonly styles = styles
}
